/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/QaArchivedTemplateList.tsx
 * FILE_ID: JOBHUB-QA-ARCHIVED-LIST-001
 * PURPOSE: Card list for the archived structure templates.
 */
import { QUICK_TEMPLATES, type QuickTemplate } from '../../../qa/archivedStructureTemplates'

export function QaArchivedTemplateList({ onPick }: { onPick: (template: QuickTemplate) => void }) {
  return (
    <div className="grid gap-2 p-3 sm:grid-cols-2">
      {QUICK_TEMPLATES.map((template) => (
        <button
          key={template.id}
          type="button"
          onClick={() => onPick(template)}
          className="rounded-lg border border-border p-3 text-left text-sm hover:border-primary"
        >
          <span className="font-medium">{template.name}</span>
          <span className="mt-1 block text-xs text-muted-foreground">{template.buildingClasses.join(', ')}</span>
        </button>
      ))}
    </div>
  )
}
